import { Reducer } from 'redux';
import ActionTypes, { TUsersState } from './types';

export const initialState: TUsersState = {
  user: null,
  users: null,
};

const reducer: Reducer<TUsersState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.CHECK_USER_R:
      return { ...state, isAuth: undefined, isAccess: undefined, error: undefined };
    case ActionTypes.CHECK_USER_S:
      return { ...state, user: action.payload, isAuth: !!action.payload };
    case ActionTypes.CHECK_USER_E:
      return { ...state, isAccess: false };
    case ActionTypes.SHOW_USERS_S:
      return { ...state, users: action.payload };
    case ActionTypes.SET_ERROR:
      return { ...state, error: action.payload };
    case ActionTypes.SET_IS_AUTH:
      return { ...state, isAuth: action.payload };
    default:
      return state;
  }
};

export { reducer as UsersReducer };
